import React from 'react';

export const Sidebar = (props) => {
    return (
        <aside className="sidebar">
            <div className="sidebar-content">{props.children}</div>
        </aside>
    );
};